import React from 'react'
import AboutMe from './components/AboutMe'
import WelcomeSection from './components/WelcomeSection'
import ProjectsSection from './components/ProjectsSection'
import ToolkitSection from './components/ToolkitSection'
import ContactMe from './components/ContactMe'
import Navbar from './components/Navbar'
import AISection from './components/AISection'
import CursorGlow from './components/CursorGlow'
import CursorTrail from './components/CursorTrail'

const Divider = () => (
	<div className='max-w-6xl mx-auto px-6 lg:px-12'>
		<div className='h-px bg-gradient-to-r from-transparent via-white/8 to-transparent' />
	</div>
)

function App() {
	return (
		<div className='font-manrope bg-[#030712] text-white overflow-x-hidden'>
			<CursorTrail />
			<CursorGlow />
			<Navbar />
			<WelcomeSection />
			<Divider />
			<ProjectsSection />
			<Divider />
			<AboutMe />
			<Divider />
			<ToolkitSection />
			<Divider />
			<AISection />
			<Divider />
			<ContactMe />
		</div>
	)
}

export default App
